/* ARU Free-Shipping Firetruck Bar — site-wide updater (2026-07-04)
 * Keeps every .aru-fst on the page in sync with the cart. Updates on load and
 * after any AJAX cart mutation (fetch-wrapped: /cart/add|change|update|clear),
 * plus common theme events, and animates the truck when progress changes.
 */
(function () {
  'use strict';
  if (window.__aruFstInit) return;
  window.__aruFstInit = true;

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function paint(cart) {
    var bars = document.querySelectorAll('[data-aru-fst]');
    if (!bars.length) return;
    var total = cart ? cart.total_price : 0;
    bars.forEach(function (bar) {
      var T = parseInt(bar.getAttribute('data-threshold'), 10) || 50000;
      var pct = Math.max(0, Math.min(100, (total / T) * 100));
      var prev = parseFloat(bar.style.getPropertyValue('--pct')) || 0;
      bar.style.setProperty('--pct', pct + '%');
      var msg = bar.querySelector('[data-aru-fst-msg]');
      if (msg) {
        if (total >= T) {
          msg.innerHTML = '🚒 <strong>FREE shipping unlocked!</strong>';
        } else {
          msg.innerHTML = '<span class="aru-fst__sub">🚒&nbsp;</span>Add <span class="aru-fst__amt">' +
            money(T - total) + '</span> for <strong>FREE shipping</strong>';
        }
      }
      bar.classList.toggle('is-unlocked', total >= T);
      if (Math.abs(pct - prev) > 0.5) {
        bar.classList.remove('is-moving');
        void bar.offsetWidth; // reflow to restart animation
        bar.classList.add('is-moving');
        setTimeout(function () { bar.classList.remove('is-moving'); }, 700);
      }
    });
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { pending = false; paint(c); })
      .catch(function () { pending = false; });
  }

  // Wrap fetch to catch AJAX cart mutations site-wide (Dawn add/change/update)
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var url = arguments[0];
      url = (typeof url === 'string') ? url : (url && url.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var p = _fetch.apply(this, arguments);
      if (isCartMutation) { p.then(function () { setTimeout(refresh, 120); }).catch(function () {}); }
      return p;
    };
  }
  // Wrap XHR too (older add-to-cart paths)
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(refresh, 120); });
    }
    return _open.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'ajaxCart:updated'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });

  function boot() { refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
